const RELOAD_GUARD_KEY = "unitedcalculator-retired-statistics-reload";
const RELOAD_GUARD_WINDOW_MS = 30_000;

export function claimRetiredStatisticsReload(
  pathname: string,
  storage: Pick<Storage, "getItem" | "setItem">,
  now = Date.now(),
): boolean {
  try {
    const previousAttempt = storage.getItem(RELOAD_GUARD_KEY)?.split("|");
    const attemptedAt = Number(previousAttempt?.[1]);
    if (
      previousAttempt?.[0] === pathname &&
      Number.isFinite(attemptedAt) &&
      now >= attemptedAt &&
      now - attemptedAt < RELOAD_GUARD_WINDOW_MS
    ) {
      return false;
    }
    storage.setItem(RELOAD_GUARD_KEY, `${pathname}|${now}`);
    return true;
  } catch {
    return false;
  }
}
